import React from "react";
import { Skeleton } from "@mui/material";
import "./ProductSkeleton.css";

interface ProductSkeletonProps {
  count?: number;
}

const ProductSkeleton: React.FC<ProductSkeletonProps> = ({ count = 4 }) => {
  return (
    <div className="horizontal-skeleton-wrapper">
      {Array.from({ length: count }).map((_, index) => (
        <div className="horizontal-skeleton-card" key={index}>
          <Skeleton variant="rectangular" width={200} height={160} />
          <Skeleton width="60%" style={{ marginTop: 8 }} />
          <Skeleton width="40%" />
        </div>
      ))}
    </div>
  );
};

export default ProductSkeleton;
